/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

export enum AppModal {
  Settings = 'settings',
  ReconstructionParams = 'reconstruction_params',
}

// needed to ensure this is a module
export {};
